<template>
    <div>
        <div class="col-12 p-0 row">
            <div class="form-group col-md-6">
                <label class="label">Version<span class="text-danger">*</span></label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text">https://google</div>
                    </div>
                    <select v-model="selectedVersion" class="form-control custom-select">
                        <option value="fr">.fr</option>
                        <option value="com">.com</option>
                        <option value="co.uk">.co.uk</option>
                        <option value="ch">.ch</option>
                        <option value="be">.be</option>
                        <option value="ca">.ca</option>
                    </select>
                </div>
            </div>
            <div class="form-group col-md-6" v-if="selectedVersion === 'fr'">
                <label class="label">Code postal</label>
                <div class="input-group">
                    <input id="budget_mensuel" v-model="zipcode" type="number" class="form-control w-50" required="" />
                </div>
            </div>
        </div>

        <div class="col-12 p-0">
            <div class="form-group">
                <label>Mots-clés</label>
                <div class="row justify-content-between align-items-center">
                    <div class="col-md-11">
                        <textarea v-model="keywords" cols="30" rows="5" class="form-control" />
                        <small class="text-muted"> Séparer les mots clés d'un saut de ligne ou d'une virgule </small>
                    </div>
                    <div class="col-md-1 text-right">
                        <button v-if="showGoButton" type="button" class="btn btn-warning" :disabled="!keywords" @click="fetch">Go</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 p-0">
            <b-table v-if="results.length" :data="results" checkable :checked-rows.sync="checkedRows">
                <b-table-column v-slot="props" field="keyword" label="Mot clé" width="15%">
                    <span>{{ props.row.mot_cle }}</span>
                </b-table-column>
                <b-table-column v-slot="props" field="url" label="URL" width="30%">
                    <input v-model="props.row.url" type="text" class="form-control form-control-sm" />
                </b-table-column>
                <b-table-column v-slot="props" field="position" label="Position" width="1em" cell-class="text-center">
                    <span>{{ props.row.position_initiale }}</span>
                </b-table-column>
                <b-table-column v-slot="props" field="rd" label="RD" width="1em" cell-class="text-center">
                    <span>{{ props.row.rd_kw }}</span>
                </b-table-column>
                <b-table-column v-slot="props" field="note" label="Note">
                    <input v-model="props.row.note_divers" type="text" class="form-control form-control-sm" />
                </b-table-column>
            </b-table>
        </div>
        <Toaster ref="toaster" />
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import Toaster from '@/components/UI/Toaster.vue'

    export default {
        name: 'NewCampaignUrl',
        components: { Toaster },

        props: {
            url: {
                required: true,
                type: String
            },
            showAll: {
                required: false,
                default: true,
                type: Boolean
            },
            showGoButton: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                loadingModal: false,
                selectedLang: 'fr',
                selectedVersion: 'fr',
                zipcode: null,
                keywords: null,
                checkedRows: [],
                results: [],
                isFetching: false
            }
        },
        methods: {
            ...mapActions('campaigns', ['fetchGoogleResults']),
            fetch({ url = null, accompagnement_id = null } = {}) {
                this.isFetching = true
                this.loadingModal = true

                const finalUrl = url || this.url
                const finalAccompagnementId = accompagnement_id ?? parseInt(this.$route.query.id)

                const keywordsArray = this.keywords?.trim().split(/\n/g).filter(Boolean) || []

                return this.fetchGoogleResults({
                    keywords: keywordsArray,
                    lang: this.selectedLang,
                    version: this.selectedVersion,
                    ...(this.zipcode && { zipcode: this.zipcode }),
                    url: encodeURI(finalUrl),
                    accompagnement_id: finalAccompagnementId
                })
                    .then(data => {
                        this.results = data
                    })
                    .catch(error => {
                        this.$refs.toaster.fire('error', "Erreur", error.response?.data?.message || "Erreur inconnue")
                    })
                    .finally(() => {
                        this.loadingModal = false
                        this.isFetching = false
                        this.$emit('closeModal')
                        this.$refs.toaster.fire('success', "Succès", "Les mots-clés vont être mis à jour")
                    })
            },

            rowsChecked(rows) {
                this.checkedRows = rows
            },

            clean() {
                this.checkedRows = []
                this.results = []
                this.keywords = null
            },

            getCheckedRows() {
                return this.checkedRows
            }
        }
    }
</script>
